/* global Fw */

(function($, d, g) {
	'use strict';
	
	var updateSubscribe = function() {
		var $btn = $(this);
		if (!$btn.hasClass("processing")) {
			$btn.addClass("processing");
			ajax("/action/updatePerson?ajax=true&newsletter=true", function(response) {
				$btn.removeClass("processing");
				if (response.indexOf("success") > -1) {
					$btn.closest(".site-footer-newsletter-ctn").hide();
					Fw.component.models().form.showSuccessPopup("subscribe-newsletter-success");
				} else {
					//Error
				}
			}, true);
		}
	};
	
	var openMCSignupForm = function() {
		openWindow("mc_embed_signup", true);
	};
	
	var closeMCSignupForm = function() {
		closeWindow("mc_embed_signup");
	};
	
	var init = function () {
//		$("#mc-subscribe-btn").on("click", Fw.component.models().utils.showMCPopup);
		$("#mc-subscribe-btn").on("click", openMCSignupForm);
		$("#mc_embed_signup .mc-closeModal").on("click", closeMCSignupForm);
		$("#mg2-subscribe-btn").on("click", updateSubscribe);
	};
	
	$(g).ready(init);
	
})(jQuery, document, window);
